import React from "react";

export default class AddressRenderer extends React.Component<any>
{
    createAddress(obj: any)
    {
        const address = [];

        for (const key in obj)
        {
            if (obj[key] !== null && obj[key] != "")
            {
                address.push(obj[key]);
            }
        }

        return address.join(", ");
    }

    render(): React.ReactNode
    {
        const address = this.props.value as Address;

        const limitedAddress = {
            street: address.street,
            city: address.city,
            state: address.state,
            postalCode: address.postalCode
        };

        if (address.street == null && address.city == null && address.state == null && address.postalCode == null)
            return <b> - </b>;

        return <b>
            {this.createAddress(limitedAddress)}
        </b>;
    }
}